import { useState, useEffect } from 'react';

const useWindowResize = () => {
  const [isDesktopView, setIsDesktopView] = useState(window.innerWidth > 768);

  const handleResize = () => {
    setIsDesktopView(window.innerWidth > 768);
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isDesktopView;
};

export default useWindowResize;
